<template>
  <div>
    <div class="admin">
      <div class="fluid-container">
        <div class="row no-gutters">
          <!-- menu admin -->
          <div class="col-3 menu-admin-wrap">
            <menu-admin></menu-admin>
          </div>
          <!-- menu admin -->

          <!-- main -->
          <div class="col-xs-12 col-md-9 col-lg-9 col-xl-9 main full-mb">
            <div class="row">
              <div class="col-12 mb-2">
                <div class="title-admin">
                  <h1 class="display-5 font-weight-black ">
                    Reportes
                  </h1>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col">
                <!-- tabs -->
                <v-tabs background-color="#fff" color="primary" centered grow>
                  <v-tabs-slider></v-tabs-slider>

                  <v-tab href="#hoy">HOY</v-tab>
                  <v-tab href="#mes">MES</v-tab>

                  <!-- HOY tab -->
                  <v-tab-item
                    value="hoy"
                    background-color="transparent"
                    class="mt-5"
                  >
                    <!-- subtitulo -->
                    <div class="row">
                      <div class="col">
                        <h2 class="font-weight-black subtitle">Ventas</h2>
                      </div>
                    </div>
                    <!-- /subtitulo -->

                    <!-- row -->
                    <div class="row mt-1">
                      <!-- box -->
                      <div class="col-xs-12 col-md-12 col-lg-6 col-xl-6">
                        <div class="box-info">
                          <div class="icon-wrap">
                            <v-btn fab small color="black">
                              <v-icon color="white">attach_money</v-icon>
                            </v-btn>
                          </div>
                          <div class="top">
                            <h2>Total de ventas del día de hoy</h2>
                          </div>
                          <div class="monto">
                            <h1 class="big">${{ corte_hoy }}</h1>
                          </div>
                        </div>
                      </div>
                      <!-- /box -->

                      <!-- box -->
                      <div class="col-xs-12 col-md-12 col-lg-6 col-xl-6">
                        <div class="box-info">
                          <div class="icon-wrap">
                            <v-btn fab small color="black">
                              <v-icon color="white">shopping_basket</v-icon>
                            </v-btn>
                          </div>
                          <div class="top">
                            <h2>Número de ventas el día de hoy</h2>
                          </div>
                          <div class="monto">
                            <h1 class="big">{{ ventas_hoy }} ventas</h1>
                          </div>
                        </div>
                      </div>
                      <!-- /box -->
                    </div>
                    <!-- /row -->

                    <!-- row -->
                    <div class="row">
                      <!-- box -->
                      <div class="col-xs-12 col-md-12 col-lg-4 col-xl-4">
                        <div class="box-info">
                          <div class="icon-wrap">
                            <v-btn fab small color="black">
                              <v-icon color="white">attach_money</v-icon>
                            </v-btn>
                          </div>
                          <div class="top">
                            <h2>total de Ventas en efectivo hoy</h2>
                          </div>
                          <div class="monto">
                            <h1 class="big">${{ ventas_hoy_efectivo }}</h1>
                          </div>
                        </div>
                      </div>
                      <!-- /box -->

                      <!-- box -->
                      <div class="col-xs-12 col-md-12 col-lg-4 col-xl-4">
                        <div class="box-info">
                          <div class="icon-wrap">
                            <v-btn fab small color="black">
                              <v-icon color="white">attach_money</v-icon>
                            </v-btn>
                          </div>
                          <div class="top">
                            <h2>total de Ventas depósito hoy</h2>
                          </div>
                          <div class="monto">
                            <h1 class="big">${{ ventas_hoy_deposito }}</h1>
                          </div>
                        </div>
                      </div>
                      <!-- /box -->

                      <!-- box -->
                      <div class="col-xs-12 col-md-12 col-lg-4 col-xl-4">
                        <div class="box-info">
                          <div class="icon-wrap">
                            <v-btn fab small color="black">
                              <v-icon color="white">attach_money</v-icon>
                            </v-btn>
                          </div>
                          <div class="top">
                            <h2>total de Ventas tarjeta hoy</h2>
                          </div>
                          <div class="monto">
                            <h1 class="big">${{ ventas_hoy_tarjeta }}</h1>
                          </div>
                        </div>
                      </div>
                      <!-- /box -->
                    </div>
                    <!-- /row -->

                    <!-- subtitulo -->
                    <div class="row mt-3">
                      <div class="col">
                        <h2 class="font-weight-black subtitle">Gastos</h2>
                      </div>
                    </div>
                    <!-- /subtitulo -->

                    <div class="row mt-1">
                      <!-- box -->
                      <div class="col-xs-12 col-md-12 col-lg-6 col-xl-6">
                        <div class="box-info">
                          <div class="icon-wrap">
                            <v-btn fab small color="black">
                              <v-icon color="white">credit_card</v-icon>
                            </v-btn>
                          </div>
                          <div class="top">
                            <h2>total de Gastos del día de hoy</h2>
                          </div>
                          <div class="monto">
                            <h1 class="big">${{ gastos_hoy }}</h1>
                          </div>
                        </div>
                      </div>
                      <!-- /box -->
                    </div>
                  </v-tab-item>
                  <!-- HOY tab -->

                  <!-- MES tab -->
                  <v-tab-item
                    value="mes"
                    background-color="transparent"
                    class="mt-5"
                  >
                    <!-- subtitulo -->
                    <div class="row mt-3">
                      <div class="col">
                        <h2 class="font-weight-black subtitle">Ventas</h2>
                      </div>
                    </div>
                    <!-- /subtitulo -->

                    <div class="row mt-4">
                      <!-- box -->
                      <div class="col-xs-12 col-md-12 col-lg-6 col-xl-6">
                        <div class="box-info">
                          <div class="icon-wrap">
                            <v-btn fab small color="black">
                              <v-icon color="white">attach_money</v-icon>
                            </v-btn>
                          </div>
                          <div class="top">
                            <h2>Total de ventas en el mes</h2>
                          </div>
                          <div class="monto">
                            <h1 class="big">${{ corte_mes }}</h1>
                          </div>
                        </div>
                      </div>
                      <!-- /box -->

                      <!-- box -->
                      <div class="col-xs-12 col-md-12 col-lg-6 col-xl-6">
                        <div class="box-info">
                          <div class="icon-wrap">
                            <v-btn fab small color="black">
                              <v-icon color="white">attach_money</v-icon>
                            </v-btn>
                          </div>
                          <div class="top">
                            <h2>Número de Ventas en el mes</h2>
                          </div>
                          <div class="monto">
                            <h1 class="big">{{ ventas_numero_mes }} ventas</h1>
                          </div>
                        </div>
                      </div>
                      <!-- /box -->

                      <!-- subtitulo -->
                      <div class="row mt-3">
                        <div class="col">
                          <h2 class="font-weight-black subtitle">Gastos</h2>
                        </div>
                      </div>
                      <!-- /subtitulo -->

                      <!-- box -->
                      <div class="col-xs-12 col-md-12 col-lg-6 col-xl-6">
                        <div class="box-info">
                          <div class="icon-wrap">
                            <v-btn fab small color="black">
                              <v-icon color="white">credit_card</v-icon>
                            </v-btn>
                          </div>
                          <div class="top">
                            <h2>Total de gastos en el mes</h2>
                          </div>
                          <div class="monto">
                            <h1 class="big">${{ gastos_mes }}</h1>
                          </div>
                        </div>
                      </div>
                      <!-- /box -->
                    </div>
                  </v-tab-item>
                  <!-- MES tab -->
                </v-tabs>
              </div>
            </div>
          </div>
          <!-- /main -->
        </div>
      </div>
    </div>
    <!-- /desktop -->
  </div>
</template>

<script>
const axios = require("axios");
export default {
  data() {
    return {
      corte_hoy: "",
      ventas_hoy: "",
      productos_registrados: "",
      corte_mes: "",
      ventas_numero_mes: "",
      categorias_registradas: "",
      gastos_hoy: "",
      gastos_mes: "",
      ventas_hoy_efectivo: "",
      ventas_hoy_deposito: "",
      ventas_hoy_tarjeta: "",
    };
  },
  methods: {
    getCorteHoy() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getCorteHoy"
        )
        .then((response) => {
          if (response.data == "") {
            this.corte_hoy = 0;
          } else {
            this.corte_hoy = response.data;
          }
        })
        .catch((error) => console.log(error));
    },
    getVentasHoyNumero() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasHoyNumero"
        )
        .then((response) => {
          if (response.data == "") {
            this.ventas_hoy = 0;
          } else {
            this.ventas_hoy = response.data;
          }
        })
        .catch((error) => console.log(error));
    },
    getVentasMesNumero() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasMesNumero"
        )
        .then((response) => {
          console.log(response);
          this.ventas_numero_mes = response.data;
        })
        .catch((error) => console.log(error));
    },
    getProductosNumeroRegistrados() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getProductosNumeroRegistrados"
        )
        .then((response) => {
          this.productos_registrados = response.data;
        })
        .catch((error) => console.log(error));
    },

    getCategoriasNumeroRegistrados() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getCategoriasNumeroRegistrados"
        )
        .then((response) => {
          this.categorias_registradas = response.data;
        })
        .catch((error) => console.log(error));
    },

    getCorteMes() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getCorteMes"
        )
        .then((response) => {
          console.log(response);
          this.corte_mes = response.data;
        })
        .catch((error) => console.log(error));
    },

    getGastosHoy() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getGastosHoy"
        )
        .then((response) => {
          if (response.data.total == 0) {
            this.gastos_hoy = "0";
          }
          this.gastos_hoy = response.data;
        })
        .catch((error) => console.log(error));
    },

    getVentasHoyEfectivo() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasHoyEfectivo"
        )
        .then((response) => {
          if (response.data.total == 0) {
            this.ventas_hoy_efectivo = "0";
          }
          this.ventas_hoy_efectivo = response.data;
        })
        .catch((error) => console.log(error));
    },

    getVentasHoyDeposito() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasHoyDeposito"
        )
        .then((response) => {
          if (response.data.total == 0) {
            this.ventas_hoy_deposito = "0";
          }
          this.ventas_hoy_deposito = response.data;
        })
        .catch((error) => console.log(error));
    },

    getVentasHoyTarjeta() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getVentasHoyTarjeta"
        )
        .then((response) => {
          if (response.data.total == 0) {
            this.ventas_hoy_tarjeta = "0";
          }
          this.ventas_hoy_tarjeta = response.data;
        })
        .catch((error) => console.log(error));
    },

    getGastosMes() {
      axios
        .get(
          "https://vossmueblerias.com.mx/backend/api/admin/admin__controller.php?ot=getGastosMes"
        )
        .then((response) => {
          if (response.data.total == 0) {
            this.gastos_mes = "0";
          }
          this.gastos_mes = response.data;
        })
        .catch((error) => console.log(error));
    },
  },

  mounted() {
    this.getGastosHoy();
    this.getGastosMes();
    this.getCorteHoy();
    this.getCorteMes();
    this.getVentasMesNumero();
    this.getVentasHoyNumero();
    this.getProductosNumeroRegistrados();
    this.getCategoriasNumeroRegistrados();
    this.getVentasHoyEfectivo();
    this.getVentasHoyDeposito();
    this.getVentasHoyTarjeta();
  },
};
</script>
